import { INPUT_FIELD_TYPE } from '@components/DynamicFormField/constant';

// Source configuration fields generator
export const getSourceFields = ({ clients, sourceSubClients, sourceCurrencies }) => [
  {
    name: 'sourceClient',
    label: 'Source Client',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    size: 'sm',
    isRequired: true,
    options: clients.map(client => ({ value: client, label: client }))
  },
  {
    name: 'sourceSubClient',
    label: 'Source SubClient',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    size: 'sm',
    isRequired: true,
    options: sourceSubClients.map(sc => ({ value: sc, label: sc })),
    isDisabled: sourceSubClients.length === 0
  },
  {
    name: 'sourceCurrency',
    label: 'Source Currency',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    size: 'sm',
    isRequired: true,
    options: sourceCurrencies.map(curr => ({ value: curr, label: curr })),
    isDisabled: sourceCurrencies.length === 0
  }
];

// Destination configuration fields generator
export const getDestinationFields = ({ clients, sourceSubClients, sourceCurrencies }) => [
  {
    name: 'destinationClient',
    label: 'Destination Client',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    size: 'sm',
    isRequired: true,
    options: clients.map(client => ({ value: client, label: client }))
  },
  {
    name: 'destinationSubClient',
    label: 'Destination SubClient',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    size: 'sm',
    isRequired: true,
    options: sourceSubClients.map(sc => ({ value: sc, label: sc })),
    isDisabled: sourceSubClients.length === 0
  },
  {
    name: 'destinationCurrency',
    label: 'Destination Currency',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    size: 'sm',
    isRequired: true,
    options: sourceCurrencies.map(curr => ({ value: curr, label: curr })),
    isDisabled: sourceCurrencies.length === 0
  }
];

// Copy options configuration fields
export const COPY_OPTIONS_FIELDS = [
  {
    name: 'copyLimits',
    label: 'Limits',
    fieldType: INPUT_FIELD_TYPE.CHECKBOX,
    size: 'md'
  },
  {
    name: 'copyPayoutVendors',
    label: 'Payout Vendors',
    fieldType: INPUT_FIELD_TYPE.CHECKBOX,
    size: 'md'
  },
  {
    name: 'copyExchangeSettings',
    label: 'Exchange Settings',
    fieldType: INPUT_FIELD_TYPE.CHECKBOX,
    size: 'md'
  },
  {
    name: 'copySlaSettings',
    label: 'SLA Settings',
    fieldType: INPUT_FIELD_TYPE.CHECKBOX,
    size: 'md'
  },
  {
    name: 'copyFeeSettings',
    label: 'Fee Settings',
    fieldType: INPUT_FIELD_TYPE.CHECKBOX,
    size: 'md'
  }
];

// Initial form data
export const INITIAL_FORM_DATA = {
  sourceClient: '',
  sourceSubClient: '',
  sourceCurrency: '',
  copyLimits: true,
  copyPayoutVendors: true,
  copyExchangeSettings: true,
  copySlaSettings: true,
  copyFeeSettings: true
};

